<template>
  <a-card class="card" title="个人/团队数据看板">
    <time-bar ref="timeTeam" @change="getData"></time-bar>
    <div ref="userData" style="height:400px"></div>
  </a-card>
</template>

<script>
import moment from "moment";
import Echart from "echarts";
import TimeBar from "@/components/time-bar.component";
import Api from "@/api";
export default {
  name: "UserDataBoard",
  components: { TimeBar },
  methods: {
    async getData(payload) {
      this.chart.showLoading();
      let { counts } = await Api.dashboard.teamData({
        created_start: payload.value[0],
        created_end: payload.value[1]
      });
      this.chart.hideLoading();
      let data;
      data = [
        { value: counts.recommend_count, name: "推荐" },
        { value: counts.interview_count, name: "一面" },
        { value: counts.offer_count, name: "offer" },
        { value: counts.entry_count, name: "入职" },
        { value: counts.complete_count, name: "过保" },
        { value: counts.settled_count, name: "结单" }
      ];
      this.updataChart(data);
    },
    initChart() {
      this.chart = Echart.init(this.$refs.userData);
      let option = {
        // tooltip: {
        //   trigger: "item",
        //   formatter(item) {
        //     return `${item.data.name}：${item.data.value}`;
        //   }
        // },
        toolbox: {
          orient: "vertical",
          top: "80%",
          left: "2%",
          feature: {
            // saveAsImage: {}
          }
        },
        legend: {
          orient: "vertical",
          left: "15%",
          top: "center",
          data: ["推荐", "一面", "offer", "入职", "过保", "结单"]
        },
        series: [
          {
            type: "funnel",
            width: "50%",
            height: "80%",
            left: "25%",
            top: "10%",
            label: {
              formatter(item) {
                return `${item.data.name}`;
              }
            },
            labelLine: {
              length: 50
            }
          },
          {
            type: "funnel",
            width: "50%",
            height: "80%",
            left: "25%",
            top: "10%",
            label: {
              position: "inside",
              formatter(item) {
                return `${item.data.value}`;
              }
            },
            labelLine: {
              length: 50
            }
          }
        ]
      };
      this.chart.setOption({ ...option });
    },
    updataChart(data) {
      this.chart.setOption({
        dataset: {
          source: data
        }
      });
    }
  },
  mounted() {
    this.initChart();
    this.$refs.timeTeam.init();
  }
};
</script>

<style scoped lang="scss"></style>
